module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/68_UCU4801 Sleeveless Sweater.png";